package one.healthium.base.utils

import androidx.compose.runtime.Composable
import co.touchlab.kermit.Logger
import androidx.compose.ui.geometry.Size

@Composable
fun <T> Map<DeviceClass, T>.current(): T? {
    val size = screenSize
    return get(DeviceClass.from(size))
}

fun <T> Map<DeviceClass, T>.default(): T? {
    return get(DeviceClass.Default)
}

expect val screenSize: Size


